var map = {
	"./add.svg": "2a1f",
	"./address-complement.svg": "c698",
	"./big-add.svg": "3124",
	"./call-close.svg": "9443",
	"./call-init.svg": "49dd",
	"./card-chat.svg": "2b32",
	"./card-down.svg": "e477",
	"./card-flag.svg": "7348",
	"./card-localize-on-map-disabled.svg": "05be",
	"./card-localize-on-map.svg": "876e",
	"./card-log.svg": "2d51",
	"./caret-down.svg": "1272",
	"./caret-up.svg": "b142",
	"./change.svg": "f86e",
	"./check.svg": "cb7e",
	"./checkmark.svg": "4597",
	"./client-details.svg": "3fb1",
	"./client-group.svg": "d467",
	"./cog.svg": "bca1",
	"./copy.svg": "0fec",
	"./credit-card.svg": "c684",
	"./delete-order-item.svg": "c213",
	"./delete.svg": "8a0c",
	"./dropdown-request-contact.svg": "b38f",
	"./dropdown.svg": "bafe",
	"./edit.svg": "7003",
	"./flag-disabled.svg": "ba74",
	"./flag.svg": "1121",
	"./header-calendar.svg": "019a",
	"./header-flag.svg": "b539",
	"./header-status.svg": "f95c",
	"./local.svg": "364a",
	"./log.svg": "c354",
	"./menu-config.svg": "6405",
	"./mini-chart.svg": "83ba",
	"./phone.svg": "ab9d",
	"./remove.svg": "b965",
	"./request-check.svg": "675e",
	"./request-contact-del.svg": "c93b",
	"./request-edit.svg": "3b54",
	"./request-flag.svg": "e00a",
	"./request-not-check.svg": "c3e5",
	"./request-search-addresses.svg": "0ee5",
	"./request-search-body.svg": "853d",
	"./request-search-graf.svg": "0c69",
	"./request-search.svg": "49a4",
	"./request-send.svg": "b842",
	"./request-status.svg": "7e2b",
	"./request-tab-contact.svg": "e6aa",
	"./request-tab-order.svg": "6e1f",
	"./request-tab-search.svg": "a9fa",
	"./request-trash.svg": "7fba",
	"./request-up-active.svg": "1add",
	"./request-up.svg": "b23e",
	"./search.svg": "4c72",
	"./status-selection.svg": "a149",
	"./status.svg": "8fd0",
	"./stock.svg": "c5ea",
	"./supplier-details.svg": "f2a9",
	"./wh-call.svg": "366a",
	"./wh-chat.svg": "64db",
	"./wh-close.svg": "553a",
	"./wh-down.svg": "39a67",
	"./wh-log.svg": "f7d3",
	"./wh-request-code.svg": "e307",
	"./wh-share.svg": "25b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb63";